import { c as _c } from "react/compiler-runtime";
import { SortableItem } from '@/shared/lib/dnd';
import { DndContext, DragEndEvent, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';
import { SortableContext, arrayMove, horizontalListSortingStrategy, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { useTranslations } from 'next-intl';
import styles from './styles.module.scss';
import ImageCount from '../ImageCount';
import { Thumbnail } from './Thumbnail';
type ImageState = 'pending' | 'completed' | 'failed';
type Image = {
  id: string;
  src: string;
  state?: ImageState;
};
type Props = {
  title?: string;
  maxCount: number;
  images: Image[];
  tooltip?: string;
  onDelete?: (id: string) => void;
  onSortImages?: (reorderedIds: string[]) => void;
};
export default function Grid(t0) {
  const $ = _c(33);
  const {
    title,
    maxCount,
    images,
    tooltip,
    onDelete,
    onSortImages
  } = t0;
  const t = useTranslations("imageUpload");
  let t1;
  if ($[0] !== t || $[1] !== title) {
    t1 = title ?? t("grid.title");
    $[0] = t;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resolvedTitle = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      activationConstraint: {
        distance: 3
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      coordinateGetter: sortableKeyboardCoordinates
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const sensors = useSensors(useSensor(PointerSensor, t2), useSensor(KeyboardSensor, t3));
  let t4;
  if ($[5] !== onDelete) {
    t4 = id => {
      onDelete?.(id);
    };
    $[5] = onDelete;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleDelete = t4;
  let t5;
  if ($[7] !== images) {
    t5 = images.filter(_temp);
    $[7] = images;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const completedImages = t5;
  let t6;
  if ($[9] !== images || $[10] !== onSortImages) {
    t6 = event => {
      if (!onSortImages) {
        return;
      }
      const {
        active,
        over
      } = event;
      if (over && active.id !== over.id) {
        const activeIndex = images.findIndex(image_0 => image_0.id === active.id);
        const overIndex = images.findIndex(image_1 => image_1.id === over.id);
        if (activeIndex !== -1 && overIndex !== -1) {
          const newImages = arrayMove(images, activeIndex, overIndex);
          onSortImages(newImages.map(_temp2));
        }
      }
    };
    $[9] = images;
    $[10] = onSortImages;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleDragEnd = t6;
  let t7;
  if ($[12] !== completedImages.length || $[13] !== maxCount || $[14] !== resolvedTitle || $[15] !== tooltip) {
    t7 = <ImageCount label={resolvedTitle} tooltip={tooltip} imageCount={completedImages.length} maxImageCount={maxCount} />;
    $[12] = completedImages.length;
    $[13] = maxCount;
    $[14] = resolvedTitle;
    $[15] = tooltip;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handleDelete || $[18] !== images || $[19] !== onSortImages) {
    t8 = !onSortImages && <>{images.map(image_3 => <div key={image_3.id} className={styles.image}><Thumbnail id={image_3.id} src={image_3.src} state={image_3.state} onDelete={handleDelete} /></div>)}</>;
    $[17] = handleDelete;
    $[18] = images;
    $[19] = onSortImages;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== handleDelete || $[22] !== handleDragEnd || $[23] !== images || $[24] !== onSortImages || $[25] !== sensors) {
    t9 = onSortImages && <DndContext sensors={sensors} modifiers={[restrictToHorizontalAxis]} onDragEnd={handleDragEnd}><SortableContext items={images.map(_temp3)} strategy={horizontalListSortingStrategy}>{images.map((image_5, index) => <SortableItem key={image_5.id} id={image_5.id}><div className={styles.image}><Thumbnail id={image_5.id} src={image_5.src} state={image_5.state} order={index + 1} onDelete={handleDelete} /></div></SortableItem>)}</SortableContext></DndContext>;
    $[21] = handleDelete;
    $[22] = handleDragEnd;
    $[23] = images;
    $[24] = onSortImages;
    $[25] = sensors;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <div className={styles.grid}>{t8}{t9}</div>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t7) {
    t11 = <div>{t7}{t10}</div>;
    $[30] = t10;
    $[31] = t7;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}
function _temp3(image_4) {
  return image_4.id;
}
function _temp2(image_2) {
  return image_2.id;
}
function _temp(image) {
  return image.state === "completed";
}